/** URL token used in `/projects/:name` to represent the dashboard's
 *  "(no project)" placeholder bucket — i.e. proxy keys whose `project`
 *  column is NULL. The backend's `project_service.parse_project_param`
 *  decodes this same string to `None` and runs `WHERE project IS NULL`.
 *
 *  Keep both sides in lockstep: if you change this token, update
 *  `backend/app/services/project_service.py` `UNSET_TOKEN` too.
 */
export const PROJECT_UNSET_TOKEN = "__unset__";
